import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

import { CustomTitleService } from '../shared/service/custom-title/custom-title.service';

@Component({
  selector: 'cc-company-home-page',
  templateUrl: 'company-home-page.component.html',
  styleUrls: ['home-page.component.scss'],
})
export class CompanyHomePageComponent implements OnInit, OnDestroy {
  unSubscribe = new Subject<void>();
  companyId;

  constructor(private readonly customTitleService: CustomTitleService) {}

  ngOnInit() {
    this.customTitleService.setTitle(`Activity - Dashpivot`);
  }

  ngOnDestroy(): void {
    this.unSubscribe.next();
    this.unSubscribe.complete();
  }
}
